import Dashboard from "pages/Dashboard/Dashboard";
import DeviceManager from "pages/DeviceManager/DeviceManager";
import TruckManager from "pages/TruckManager/TruckManager";
import ErrorReports from "pages/ErrorReports/ErrorReports";
import MissingDevicesReport from "pages/MissingDevicesReport/MissingDevicesReport";
import UserManagement from "pages/UserManagement/UserManagement";
import TagSchemeManager from "../pages/TagScheme/TagSchemeManager";
import DeviceEventsReport from "pages/DeviceEventsReports/DeviceEventsReport";
import DeviceStatusReport from "pages/DeviceStatusReports/DeviceStatusReport";
import TipPushStatusReport from "pages/TipPushStatusReport/TipPushStatusReport";


export const dashRoutes = [
  {
    name: "At a Glance",
    header: "At a Glance (As of Today)",
    route: "/dashboard",
    element: <Dashboard />
  },
]

export const truckRoutes = [
  {
    name: "Truck Manager",
    header: "Truck Manager",
    route: "/truck-manager",
    element: <TruckManager />
  },
]

export const tagSchemeRoutes = [
  {
    name: "Tag Scheme Manager",
    header: "Tag Scheme Manager",
    route: "/Tag-Scheme-manager",
    element: <TagSchemeManager />
  },
]

export const reportRoutes = [
  {
    name: "Tip Push Status Report",
    header: "Tip Push Status Report",
    route: "/Tip-push-Status-Report",
    element: <TipPushStatusReport/>
  },
  {
    name: "Device Status Report",
    header: "Device Status Report",
    route: "/Device-Status-Report",
    element: <DeviceStatusReport/>
  },
  {
    name: "Device Events Report",
    header: "Device Events Report",
    route: "/Device-Events-reports",
    element: <DeviceEventsReport/>
  },
  {
    name: "Device Events Failed To Process Report",
    header: "Device Events Failed To Process Report",
    route: "/error-reports",
    element: <ErrorReports />
  },
  {
    name: "Missing Device Event Report",
    header: "Missing Device Event Report",
    route: "/missing-devices",
    element: <MissingDevicesReport />
  }
]
export const deviceRoutes = [
  {
    name: "Device Manager",
    header: "Device Manager",
    route: "/device-manager",
    element: <DeviceManager />
  },


  // {
  //   name: "Tip Status Info",
  //   header: "Tip Status",
  //   route: "/tip-status",
  //   element: <TipStatus />
  // },
  // {
  //   name: "Observation Status Info",
  //   header: "Observation Status",
  //   route: "/observation-status",
  //   element: <ObservationStatus />
  // },
  // {
  //   name: "Device Heartbeats Info",
  //   header: "Device Heartbeats",
  //   route: "/device-heartbeats",
  //   element: <DeviceHeartbeats />
  // },

]

export const adminRoutes = [
  {
    name: "User Management",
    header: "User Management",
    route: "/user-management",
    element: <UserManagement />
  },
]
